<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)" class="sitebuilder-element-container big-is-receiver"
       element="SliderGroupComponent"
       :label="this.internal_config.label"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)"
       :style="style()" v-on:click="focusElement($event)">
    <vue-draggable-resizable v-bind:w="getWidth()" v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" :draggable="false" :enable-native-drag="true"
                             class="page-gallery"
                             v-bind:style="styleGallery()"
                             :data-preview="$props.preview">
      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-SliderGroupComponent'>
        <img src="static/images/icons/add.svg"
             v-tooltip="{content:$t('ct-option-add-page'),  class: 'tooltip-custom'}"
             class="svg-icon normal-action" @click="addSliderPage()"/>
        <div class="mdi mdi-arrow-left-circle navigation-item-blue" @click="prevSliderEdition"
             style="font-size: 20px;cursor: pointer"
             v-tooltip="{content:$t('ct-option-prev-slider'),  class: 'tooltip-custom'}"></div>
        <div class="mdi mdi-arrow-right-circle navigation-item-blue" @click="nextSliderEdition"
             style="font-size: 20px;cursor: pointer"
             v-tooltip="{content:$t('ct-option-next-slider'),  class: 'tooltip-custom'}"></div>
      </options-element-bar>

      <div v-for="(element,index) in elements"
           v-show=" (!$props.preview && internal_config.currentIndex === index) || $props.preview"
           :class="`
           slider-page-${index}
           ${internal_config.effectSlide === 'side-padding'?`side-padding-page side-padding-page-${index}`:''}
           height-100 minHeightUnsetDesk`"
           v-bind:style="{
                          borderRadius: radius,
                          background: background,
                          border : border,
                          // boxShadow: boxShadow,
                          paddingTop : paddingTop,
                          paddingLeft : paddingLeft,
                          paddingRight : paddingRight,
                          paddingBottom : paddingBottom,
                          minHeight : minHeight
                          }">
        <component :is="element.name" :config="element.config" :key="index" :ref="`slider-page-${element.id}`"
                   :id="element.id" :height_start="index" :preview="preview" :childs="element.childs"
                   @setCallbackChangeDevice="setCallbackChangeDevice"></component>
      </div>


      <div class="slider-navigation-page" v-show="arrowOptions && $props.preview"
           v-bind:style="{
        paddingTop : paddingTop,
        paddingLeft : paddingLeft,
        paddingRight : paddingRight,
        paddingBottom : paddingBottom,
        }"
      >
        <a v-show="arrowOptions" class="carousel-control-prev" :href="'#SliderGroupComponent' + this.id">
          <div class="mdi mdi-arrow-left-circle" @click="prevSlider" :style="styleArrow()"></div>
        </a>
        <a v-show="arrowOptions" class="carousel-control-next" :href="'#SliderGroupComponent' + this.id">
          <div class="mdi mdi-arrow-right-circle" @click="nextSlider" :style="styleArrow()"></div>
        </a>
      </div>


      <resources ref="resourcesData"></resources>

      <sync-drag :target="this"/>
    </vue-draggable-resizable>

    <div class="navigation-items" v-show="!$props.preview">
      <div>{{ $t('ct-group') }}</div>
      <div v-for="(element,index) in elements"
          :class="{active: internal_config.currentIndex == index}"
          v-on:click="setSlider(index, $event, element.id)"> {{ index }}
      </div>
    </div>

  </div>
</template>

<script>
import SliderData from "./Model";
import Resources from "./Resources.vue";
import OptionsElementBar from "../../OptionsElementBar";

export default {
  name: "SliderGroupComponent",
  props: ['config', 'childs', 'device', 'id', 'preview'],
  components: {
    OptionsElementBar,
    Resources
  },
  computed: {
    arrowOptions() {
      return this.internal_config.arrowOptions;
    },
    timerSlider() {
      return this.internal_config.timerSlider;
    },
    minHeight() {
      return this.internal_config.minHeight;
    },
    border() {
      return this.internal_config.border + '!important';
    },
    boxShadow() {
      return this.internal_config.boxShadow;
    },
    radius() {
      return this.internal_config.borderRadius;
    },
    paddingTop() {
      return this.internal_config.paddingTopContainer;
    },
    paddingLeft() {
      return this.internal_config.paddingLeftContainer;
    },
    paddingRight() {
      return this.internal_config.paddingRightContainer;
    },
    paddingBottom() {
      return this.internal_config.paddingBottomContainer;
    },
// bg-color bg-image position/bg-size bg-repeat bg-origin
    background() {
      let bg = this.internal_config.backgroundColor;

      if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {

        bg += ' url("' + this.internal_config.backgroundImage + '")';
        bg += ' ' + this.internal_config.backgroundPosition;
        bg += ' / ' + this.internal_config.backgroundSize;
        bg += ' ' + this.internal_config.backgroundRepeat;
        bg += ' ' + this.internal_config.backgroundOrigin;
      }

      return bg;
    },
  },
  data() {
    return SliderData.data();
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    },
  },
  methods: {
    showIcons() {
      if (this.$el.querySelectorAll('[element="SliderPageComponent"]').length > 1) {
        this.$el.classList.add('showIcons');
      } else {
        this.$el.classList.remove('showIcons');
      }
    },
    destroyAutoPlay() {
      clearTimeout(this.internal_config.slider);
    },
    checkExists(vm) {

      let element = document
        .getElementById(vm.id)
        .getElementsByClassName(`slider-page-${vm.internal_config.currentIndex}`);

      if (typeof element[0] === 'undefined') {
        vm.buildSlider();
      } else {
        vm.internal_config.currentIndex = 0;
        element[0].style.left = 0;
        element[0].style.position = "relative";

        if (this.internal_config.effectSlide == 'side-padding') {

          const elements = document
            .getElementById(this.id)
            .getElementsByClassName(`side-padding-page`);

          if(elements.length >= 3)
            vm.buildSidePaddingSlider();
        }

        vm.showIcons();
        vm.autoPlaySlider();
      }

    },

    buildSidePaddingSlider() {

      const elements = document
        .getElementById(this.id)
        .getElementsByClassName(`side-padding-page`);

      const margin = this.internal_config.marginBetween || 80;
      const gap = this.internal_config.gapBetween || 50;

      elements[0].style.setProperty('width', `calc(100% - ${margin * 2}px)`, "important");
      elements[0].style.setProperty('overflow', 'hidden');
      elements[0].style.setProperty('margin', '0 auto');

      elements[1].style.setProperty('margin-left', `-${margin - gap}px`);

      elements[elements.length - 1].style.setProperty('left', `calc(-100% + ${margin - gap}px)`);
    },

    buildSlider() {

      if (!this.$props.preview) return false;

      this.internal_config.currentIndex = 0;
      let vm = this;

      setTimeout(() => {
        vm.checkExists(vm);
      }, 100);

    },
    // currentIndex is matched against the index of `elements` in the template,
    // so the navigation range must come from `elements` and not from
    // `internal_config.childs`, which is a duplicated copy that can drift.
    totalPagesEdition() {
      return Array.isArray(this.elements) ? this.elements.length : 0;
    },
    prevSliderEdition() {
      const total = this.totalPagesEdition();
      const currentIndex = parseInt(this.internal_config.currentIndex, 10) || 0;

      if (total > 1) {
        this.internal_config.currentIndex = (currentIndex > 0 && currentIndex < total) ? currentIndex - 1 : total - 1;
      } else {
        this.internal_config.currentIndex = 0;
      }

    },
    nextSliderEdition() {
      const total = this.totalPagesEdition();
      const currentIndex = parseInt(this.internal_config.currentIndex, 10) || 0;

      if (total > 1) {
        this.internal_config.currentIndex = currentIndex >= total - 1 ? 0 : currentIndex + 1;
      } else {
        this.internal_config.currentIndex = 0;
      }
    },
    prevSlider() {

      if (!this.$props.preview) return false;

      const {currentIndex} = this.internal_config;
      const nextIndex = currentIndex ? currentIndex - 1 : this.$el.querySelectorAll('[element="SliderPageComponent"]').length - 1;

      const nextImage = document
        .getElementById(this.id)
        .getElementsByClassName(`slider-page-${nextIndex}`)[0];

      const prevImage = document
        .getElementById(this.id)
        .getElementsByClassName(`slider-page-${currentIndex}`)[0];

      nextImage.style.position = "relative";
      prevImage.style.position = "absolute";

      switch (this.internal_config.effectSlide) {

        case 'slide':
          nextImage.style.left = "-100%";
          prevImage.style.left = 0;

          nextImage.setAttribute(
            "class",
            `slider-page-${nextIndex} slider-in-left slider-active`
          );
          prevImage.setAttribute(
            "class",
            `slider-page-${currentIndex} slider-out-right`
          );
          prevImage.classList.remove("slider-active");
          break;

        case 'side-padding':

          const margin = this.internal_config.marginBetween || 80;
          const gap = this.internal_config.gapBetween || 50;

          const elements = document
            .getElementById(this.id)
            .getElementsByClassName(`side-padding-page`);

          if (elements.length < 3) {
            nextImage.style.left = "-100%";
            prevImage.style.left = 0;

            nextImage.setAttribute(
              "class",
              `slider-page-${nextIndex} slider-active`
            );

            prevImage.setAttribute(
              "class",
              `slider-page-${currentIndex}`
            );
            prevImage.classList.remove("slider-active");
          } else {
            for (let i = 0; i < elements.length; i++) {
              elements[i].style.setProperty('z-index', '0');
            }

            const nextElementIndex = nextIndex + 1 === elements.length ? 0 : nextIndex + 1;
            const lastElementIndex = nextIndex === 0 ? (elements.length - 1) : nextIndex - 1;

            // 100 left to 0
            elements[nextIndex].style.setProperty('width', `calc(100% - ${margin * 2}px)`, "important");
            elements[nextIndex].style.setProperty('overflow', 'hidden');
            elements[nextIndex].style.setProperty('margin', '0 auto');
            elements[nextIndex].style.setProperty('left', `0`);
            elements[nextIndex].style.setProperty('z-index', '1');

            elements[nextElementIndex].style.setProperty('margin-left', `-${margin - gap}px`);
            elements[nextElementIndex].style.setProperty('left', `100%`);
            elements[nextElementIndex].style.setProperty('z-index', '1');

            elements[lastElementIndex].style.setProperty('left', `calc(-100% + ${margin - gap}px)`);
            elements[lastElementIndex].style.setProperty('width', '100%');
            elements[lastElementIndex].style.setProperty('margin', `0`);
          }

          break;
        case 'fade':

          nextImage.style.left = 0;
          prevImage.style.left = 0;

          nextImage.setAttribute(
            "class",
            `slider-page-${nextIndex} slider-active`
          );
          $(nextImage).fadeIn();

          prevImage.setAttribute(
            "class",
            `slider-page-${currentIndex}`
          );
          prevImage.classList.remove("slider-active");
          $(prevImage).fadeOut();

          break;

        default:

          nextImage.style.left = "-100%";
          prevImage.style.left = 0;

          nextImage.setAttribute(
            "class",
            `slider-page-${nextIndex} slider-active`
          );

          prevImage.setAttribute(
            "class",
            `slider-page-${currentIndex}`
          );
          prevImage.classList.remove("slider-active");
      }


      this.internal_config.currentIndex = nextIndex;

      this.autoPlaySlider();
    },
    nextSlider() {

      if (!this.$props.preview) return false;

      const {currentIndex} = this.internal_config;

      const nextIndex =
        currentIndex === this.$el.querySelectorAll('[element="SliderPageComponent"]').length - 1 ? 0 : currentIndex + 1;

      const nextImage = document
        .getElementById(this.id)
        .getElementsByClassName(`slider-page-${nextIndex}`)[0];

      const prevImage = document
        .getElementById(this.id)
        .getElementsByClassName(`slider-page-${currentIndex}`)[0];

      nextImage.style.position = "relative";
      prevImage.style.position = "absolute";

      switch (this.internal_config.effectSlide) {

        case 'slide':
          nextImage.style.left = "100%";
          prevImage.style.left = 0;

          nextImage.setAttribute(
            "class",
            `slider-page-${nextIndex} slider-in-right slider-active`
          );
          prevImage.setAttribute(
            "class",
            `slider-page-${currentIndex} slider-out-left`
          );
          prevImage.classList.remove("slider-active");
          break;

        case 'side-padding':

          const margin = this.internal_config.marginBetween || 80;
          const gap = this.internal_config.gapBetween || 50;

          const elements = document
            .getElementById(this.id)
            .getElementsByClassName(`side-padding-page`);

          if (elements.length < 3) {
            nextImage.style.left = "100%";
            prevImage.style.left = 0;

            nextImage.setAttribute(
              "class",
              `slider-page-${nextIndex} slider-active`
            );

            prevImage.setAttribute(
              "class",
              `slider-page-${currentIndex}`
            );
            prevImage.classList.remove("slider-active");
          }else{
            for (let i = 0; i < elements.length; i++) {
              elements[i].style.setProperty('z-index', '0');
            }

            // 100 left to 0
            elements[nextIndex].style.setProperty('width', `calc(100% - ${margin * 2}px)`, "important");
            elements[nextIndex].style.setProperty('overflow', 'hidden');
            elements[nextIndex].style.setProperty('margin', '0 auto');
            elements[nextIndex].style.setProperty('left', `0`);
            elements[nextIndex].style.setProperty('z-index', '1');

            const nextElementIndex = nextIndex + 1 === elements.length ? 0 : nextIndex + 1;
            elements[nextElementIndex].style.setProperty('margin-left', `-${margin - gap}px`);
            elements[nextElementIndex].style.setProperty('left', `100%`);

            const lastElementIndex = nextIndex === 0 ? (elements.length - 1) : nextIndex - 1;
            elements[lastElementIndex].style.setProperty('left', `calc(-100% + ${margin - gap}px)`);
            elements[lastElementIndex].style.setProperty('z-index', '1');
            elements[lastElementIndex].style.setProperty('width', '100%');
          }

          break;

        case 'fade':

          nextImage.style.left = 0;
          prevImage.style.left = 0;

          nextImage.setAttribute(
            "class",
            `slider-page-${nextIndex} slider-active`
          );
          $(nextImage).fadeIn();

          prevImage.setAttribute(
            "class",
            `slider-page-${currentIndex}`
          );
          prevImage.classList.remove("slider-active");
          $(prevImage).fadeOut();

          break;

        default:

          nextImage.style.left = "100%";
          prevImage.style.left = 0;

          nextImage.setAttribute(
            "class",
            `slider-page-${nextIndex} slider-active`
          );

          prevImage.setAttribute(
            "class",
            `slider-page-${currentIndex}`
          );
          prevImage.classList.remove("slider-active");
      }

      this.internal_config.currentIndex = nextIndex;

      this.autoPlaySlider();
    },

    setSlider(index, e, element_id = null) {
      let id = 0;
      id = element_id;

      this.internal_config.currentIndex = index;

      if (id !== 0) {
        let vm = this;
        e.preventDefault();
        e.stopPropagation();
        this.$refs[`slider-page-${id}`][0].forceFocusElement();
      }
    },
    autoPlaySlider() {
      this.destroyAutoPlay();

      if (!this.$props.preview || !this.internal_config.autoPlaySlider) return false;

      this.internal_config.slider = setTimeout(() => {
        this.nextSlider();
      }, this.internal_config.timerSlider);
    },
    animation() {
      return false;
    },
    getWidth() {

      // if (this.internal_config.effectSlide === 'side-padding') {
      //   const margin = this.internal_config.marginBetween || 80;
      //   return parseInt(this.internal_config.width) - (margin * 2)
      // }

      return parseInt(this.internal_config.width)
    },
    onResize(x, y, width, height) {
      this.internal_config.width = width + "px";
      this.internal_config.height = height + "px";

      this.$refs.resourcesData.setValuesData(this);
    },
    focusElement(e) {
      this.$root.$emit("focusElement", this);
      this.$root.$emit('handlerElement', this);


      e.stopPropagation();
      e.preventDefault();
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    style() {
      return `width: ${this.internal_config.width};
                 height:  ${this.internal_config.height};
                 z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                 padding-top: ${this.internal_config.paddingTop};
                 padding-left: ${this.internal_config.paddingLeft};
                 padding-right: ${this.internal_config.paddingRight};
                 padding-bottom: ${this.internal_config.paddingBottom};
                 left:  ${this.internal_config.left};
                 top: ${this.internal_config.top}`;
    },
    styleGallery() {

      if (this.internal_config.effectSlide === 'side-padding') {
        const margin = this.internal_config.marginBetween || 80;
        return `margin-left: ${margin}px;`;
      }

    },
    styleArrow() {
      return `font-size: ${this.internal_config.arrowSize};
                color: ${this.internal_config.arrowColor}`;
    },
    styleResize() {
      return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
    },
    handler(e) {
      this.$root.$emit("focusElement", this);
      this.$root.$emit("handlerElement", this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    hover() {
      this.$emit("highlightHover", {
        name: this.name,
        posicao: this.$refs.image.getBoundingClientRect()
      });
    },

    rebuild(config) {
      let vm = this;
      this.internal_config = {};
      this.$nextTick(() => {
        vm.internal_config = config;
        this.$nextTick(() => {
          vm.buildSlider();
          this.$root.$emit('rSidebarEdition', vm);
        });
      });
    },

    setCallbackChangeDevice(values) {
      this.$emit('setCallbackChangeDevice', values);
    },

    addSliderPage() {
      let vm = this;

      if (typeof this.$eventHub.getElement(this.id) === 'undefined') {
        setTimeout(() => {
          vm.addSliderPage();
        }, 1000)
      } else {
        this.$root.$emit('createBaseElement', 'SliderPageComponent', {}, this.id);

        setTimeout(() => {
          vm.internal_config.currentIndex = vm.$el.querySelectorAll('[element="SliderPageComponent"]').length - 1;
          vm.showIcons();
        }, 1000)
      }
    },
    sendNewChilds() {

      let vm = this;

      setTimeout(() => {
        vm.$eventPointer.changePointerState(true);
        vm.$eventPointer.logChilds(vm.id, vm.elements);
        setTimeout(() => {
          vm.$eventPointer.changePointerState(true);
        }, 500)
      }, 1000)
    },
  }
  ,
  mounted() {
    let device, childs, id, config;
    ({device, childs, id, config} = this.$props);

    if (typeof config.backgroundColor === 'undefined') {
      config.backgroundColor = '#FFFFFF';
    }
    this.internal_config = config;
    this.device = device;

    if (typeof childs === 'undefined') {
      childs = [];
      this.internal_config.childs = [];
    }

    if (typeof id !== 'undefined') {
      this.id = id;
    }

    let objIds = [];
    $('[id]').each(function () {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id))
        objIds.push(this.id);
    });

    if (objIds.includes(this.id)) {
      let newId = Date.now() + parseInt(Math.random() * 10000);
      this.id = newId;

      childs.forEach((el, index) => {
        try {
          childs[index].config.parent_id = newId;
        } catch (e) {
        }
      });

      this.$refs.elem.id = newId;
    }

    this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));

    let internal_config = window.mergeRecursive(this.props, this.$props.config);
    this.internal_config = {...internal_config, ...this.internal_config};

    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });
    this.$root.$on('removeSliderPage', () => {
      let vm = this;
      setTimeout(() => {
        vm.$root.$emit('setChildsObj', vm.id);

        this.internal_config.currentIndex = 0;

        vm.showIcons();
      }, 1000);
      if (this.internal_config.currentIndex === 0) {
        this.internal_config.currentIndex++
      } else {
        this.internal_config.currentIndex--;
      }
    });

    this.$root.$on('setChildsObj', (id) => {
      if (this.id == id) {

        this.$eventPointer.logChilds(this.id, this.elements);

        let childsHub = this.$eventHub.getChilds(this.id);

        this.config.childs = childsHub;
        this.internal_config.childs = childsHub;

        this.elements = {};
        this.$nextTick(() => {
          this.elements = childsHub.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
          this.componentKey += 1;

          this.$nextTick(() => {
            this.sendNewChilds();
            this.$root.$emit('activeSort');
            this.$refs.resourcesData.setValuesData(this);
          });
        });
      }
    });


    this.$root.$on('setChildsUndoRedo', (id, childs) => {
      if (this.id == id) {
        this.$eventHub.setChilds(this.id, childs);

        this.config.childs = childs;
        this.internal_config.childs = childs;

        this.elements = {};
        this.$nextTick(() => {
          this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
          this.componentKey += 1;
        });
      }
    });

    this.buildSlider();

    let vm = this;
    setTimeout(() => {
      vm.showIcons();
    }, 1000);

    this.$refs.resourcesData.setValuesData(this);
  }
}
;
</script>
<style lang="scss">

[data-device="desktop"] {
  .minHeightUnsetDesk {
    min-height: unset !important;
  }
}

.height-100 {
  height: 100% !important;
}

.slider-modal-images {
  display: flex;
  flex-direction: column;

  :nth-child(4) {
    text-align: right;
  }
}

.slider-area-images {
  display: grid;
  grid-template-columns: repeat(4, auto);
  grid-row-gap: 10px;
  grid-column-gap: 10px;
  margin: 20px 0 20px 0;
}

.slider-box-image {
  position: relative;
  background-color: rgba(29, 64, 89, 0.8);
  border-radius: 10px;

  .slider-box-image {
    width: 100%;
    height: 150px;
    opacity: 1;
    display: block;
    transition: 0.5s ease;
    backface-visibility: hidden;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  &:hover .slider-box-image {
    opacity: 0.3;
  }

  .slider-box-option {
    transition: 0.5s ease;
    opacity: 0;
    position: absolute;
    width: 34px;
    height: 34px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    text-align: center;

    span {
      width: 100%;
      height: 100%;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      &:hover {
        background-color: gray;
      }
    }
  }

  &:hover .slider-box-option {
    opacity: 1;
  }
}

.navigation-item-blue {
  display: none;
}

.showIcons {
  .navigation-item-blue {
    display: block;
  }
}

//CSS SLIDER
.page-gallery[data-preview="true"] {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;

  //todo improve
  > div:not(.slider-navigation-page) {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 100%;
    top: 0 !important;
    background-size: cover;
    transition: 1s;
    overflow: hidden;
  }

}

.page-gallery .side-padding-page{
  overflow: hidden;

  .default-options{
    top: 0px !important;
  }
}

[data-device="mobile"], [data-device="tablet"] {
  .page-gallery[data-preview="true"] {
    > div.slider-active {
      position: relative;
    }

  }
}

.slider-navigation-page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 0;

  .carousel-control-next, .carousel-control-prev {
    color: #d1d1d1;
    font-size: 25px;
    z-index: 50;

    width: 10%
  }

  &:hover {
    cursor: pointer;
  }
}


.slider-in-right {
  left: -100%;
  -webkit-animation: slideIn 1s forwards;
  animation: slideIn 1s forwards;
}

.slider-in-left {
  left: 100%;
  -webkit-animation: slideIn 1s forwards;
  animation: slideIn 1s forwards;
}

.slider-out-right {
  -webkit-animation: slideOutRight 1s forwards;
  animation: slideOutRight 1s forwards;
}

.slider-out-left {
  -webkit-animation: slideOutLeft 1s forwards;
  animation: slideOutLeft 1s forwards;
}

@keyframes slideIn {
  100% {
    left: 0;
  }
}

@keyframes slideOutRight {
  100% {
    left: 100%;
  }
}

@keyframes slideOutLeft {
  100% {
    left: -100%;
  }
}

@-webkit-keyframes slideOutLeft {
  100% {
    left: -100%;
  }
}

@-webkit-keyframes slideIn {
  100% {
    left: 0;
  }
}

@-webkit-keyframes slideOutRight {
  100% {
    left: 100%;
  }
}

.navigation-items {
  position: absolute;
  left: -100px;
  background-color: white;
  width: 100px;
  text-align: center;
  cursor: pointer;
  color: #0080FC;
  border-radius: 5px 0 0 5px;

  div {
    padding: 5px;
  }

  div:hover, div.active {
    background-color: #0080FC;
    color: white;
  }
}

[data-device="mobile"],
[data-device="tablet"] {
  .navigation-items {
    display: none !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/SliderDropGallery/SliderGroup/SliderGroup.vue